import { Redirect } from 'expo-router';
import { BlenderOverview } from 'smoothie';

import { useActiveTheme } from '../../../common/providers/DesignSystemProvider';

export default function DesignSystemIndexPage() {
    const [activeTheme, setActiveTheme] = useActiveTheme();
    // Use environment variables over !IS_DEV to force exclusion from prod bundles.
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    return (
        <BlenderOverview theme={activeTheme} onToggleTheme={setActiveTheme} />
    );
}
